'use strict';

DoohApps.filter('HttpRemove', function () {
    return function (url) {
        if (typeof url == 'string')
            return url != null && url != undefined ? url.replace('http:', '') : url;
        else
            return url;
    }
})